// Contrast Switch
//
// Contrast Switch / Increase / Decrease contast
// And Set ore Remove local Storage Item to remember contrast setting

class ContrastSwitch {
    constructor(elem) {
        this.elem = elem;
    }

    init() {
        // If contrast is set in local Storage, add contrast class to top-level element
        if (localStorage.getItem('contrast-increase')) this.toggleContrast();

        $(this.elem).on('click', (e) => {
            e.preventDefault();
            this.setLocalStorage();
        });
    }

    toggleContrast() {
        // Add Contrast Class to top-level element
        $('html').toggleClass('p-increased-contrast-mode');
    }

    setLocalStorage() {
        // Get localStorage Contrast Item
        const contrastIncrease = localStorage.getItem('contrast-increase');

        // Set or Remove localStorage
        if (contrastIncrease) {
            localStorage.removeItem('contrast-increase');
        } else {
            localStorage.setItem('contrast-increase', '1');
        }

        // Add Contrast class to top-level element
        this.toggleContrast();
    }

}

export default ContrastSwitch;
